import { z } from "zod";
import {
  AI_ARTIFACT_MEDIA_TYPES,
  AI_CAPABILITIES,
  AI_TASK_STATUSES,
} from "@/shared/model/ai-enums";

export const taskCapabilitySchema = z.enum(AI_CAPABILITIES);
export const taskStatusSchema = z.enum(AI_TASK_STATUSES);

export const generationTaskSchema = z.object({
  taskNo: z.string(),
  modelId: z.number().int(),
  // Template-created tasks may be accepted before the model display name is
  // materialized. The stable modelId remains available for a UI fallback.
  modelName: z.string().nullish(),
  capability: taskCapabilitySchema,
  status: taskStatusSchema,
  progress: z.number().int().default(0),
  input: z.record(z.string(), z.unknown()).nullish(),
  output: z
    .object({
      text: z.string().nullish(),
      artifacts: z
        .array(
          z.object({
            fileId: z.number().int(),
            mediaType: z.enum(AI_ARTIFACT_MEDIA_TYPES).nullish(),
            contentType: z.string().nullish(),
            size: z.number().int().nullish(),
            previewUrl: z.string().nullish(),
          }),
        )
        .default([]),
    })
    .nullish(),
  usage: z
    .object({
      inputTokens: z.number().int().nullish(),
      outputTokens: z.number().int().nullish(),
      totalTokens: z.number().int().nullish(),
      generatedImageCount: z.number().int().nullish(),
      generatedVideoSeconds: z.number().int().nullish(),
      requestCount: z.number().int().nullish(),
    })
    .nullish(),
  quotedPoints: z.number().int().nullish(),
  pricingRuleId: z.number().int().nullish(),
  chargedPoints: z.number().int().nullish(),
  errorCode: z.string().nullish(),
  errorMessage: z.string().nullish(),
  initiatorType: z.string().nullish(),
  sourceType: z.string().nullish(),
  billingMode: z.string().nullish(),
  sourceTemplateId: z.number().int().nullish(),
  sourceTemplateVersionId: z.number().int().nullish(),
  createdAt: z.string(),
  completedAt: z.string().nullish(),
});

export type GenerationTask = z.infer<typeof generationTaskSchema>;
export type TaskCapability = z.infer<typeof taskCapabilitySchema>;
export type TaskStatus = z.infer<typeof taskStatusSchema>;
